import { GetterTree } from 'vuex';
import { WorldState } from './types';
import { RootState } from '../types';
import { WorldMarker } from '@/interfaces/Marker';
import { World } from '@/interfaces/world/world';
import { LibraryItem } from '@/interfaces/world/library';

export const getters: GetterTree<WorldState, RootState> = {
  /**
   * Returns the current fight for this user
   * @param state
   */
  markers(state): WorldMarker[] {
    return state.markers;
  },

  persons(state) {
    return state.persons;
  },

  personTags(state): object {
    const tagsMap: object = {};
    if (Array.isArray(state.persons)) {
      state.persons.forEach((person) => {
        let tags = ['keine Tags'];
        if (typeof person.tags !== 'undefined' && Array.isArray(person.tags)) {
          tags = person.tags;
        }

        tags.forEach((tag) => {
          if (!tagsMap.hasOwnProperty(tag)) {
            tagsMap[tag] = 1;
          } else {
            tagsMap[tag]++;
          }
        });
      });
    }
    return tagsMap;
  },

  currentWorld(state): string | null {
    return state.currentWorld;
  },

  availableWorlds(state): World[] {
    return state.availableWorlds;
  },

  library(state): LibraryItem[] {
    return state.library;
  },
};
